import { createReducer } from '../../utilities';
import {
    SUCCESS_FETCH_STATS_MAILPUSH
} from "../../../actions/entities/statistics/mailPush";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return { ...data };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_STATS_MAILPUSH]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/mailPush.js